<template>
  <div class="stat-card-white" ref="captureArea" :class="{ 'chart-empty-state': !loader && !hasChartData(data) }">
    <div class="stat-header-white">
      <span>{{ chartlabel }}</span>
      <div v-show="!loader" class="d-flex align-items-center" v-if="!loader">
        <div v-if="!loader" class="expand-block px-2 mb-1 cursor-pointer position-relative">
          <img class="cursor-pointer" @click="showtable()" src="../../assets//img/table_view.png" alt="More block" />
          <div class="more-expand">
            <span>{{ $t ? $t("navigations.data overview") : "Data overview" }}</span>
          </div>
        </div>
        <div class="expand-block px-2 mb-1 cursor-pointer" @click.prevent="expandBlock = true">
          <img src="../../assets//img/expand.png" alt="Expand block" />
        </div>
        <div class="text-center" v-on:clickout="showVisitPopup = false">
          <div class="position-relative cursor-pointer biggerfont ml-2" @click.prevent="showVisitPopup = !showVisitPopup">
            <i class="fa fa-ellipsis-v"></i>
          </div>
          <div class="plan-side-popup" ref="excludeThis" v-if="showVisitPopup">
            <div @click.prevent="showVisitPopup = false, exporttoexcell()">Export to Excel</div>
            <div @click.prevent="exporttopdf()">Export to PDF</div>
          </div>
        </div>
      </div>
    </div>

    <div class="stat-body-white d-flex flex-column" :class="{ 'h-100': loader === true }">
      <div v-if="loader" class="loader"></div>

      <!-- drilldown controls -->
      <div v-if="!loader && selectedGroups.length !== 0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
        <img class="cursor-pointer" src="../../assets/img/chart_cancel.png" @click.prevent="cancelselection()" alt="Cancel drilldown" />
        <img class="cursor-pointer" src="../../assets/img/chart_submit.png" @click.prevent="recreatechart()" alt="Apply drilldown" />
      </div>

      <div ref="chartWrapper" :class="{ 'overflow-x-auto': fromPage === 'statusReport' }" v-show="!loader" class="w-100 overflow-auto">
        <svg ref="chartContainer" class="w-100 h-auto" preserveAspectRatio="xMidYMid meet"></svg>
        <div ref="tooltip" class="tooltip"></div>
      </div>
    </div>
  </div>

  <enlargerpopup v-if="expandBlock === true" @closeModal="onClosePopup">
    <div class="stat-body-white d-flex flex-column">
      <div v-if="!loader && selectedGroups.length !== 0" class="selectdrill d-flex flex-row-reverse gap-2 w-100">
        <img class="cursor-pointer" src="../../assets/img/chart_cancel.png" @click.prevent="cancelselection()" alt="Cancel drilldown" />
        <img class="cursor-pointer" src="../../assets/img/chart_submit.png" @click.prevent="recreatechart()" alt="Apply drilldown" />
      </div>
      <div ref="popupWrapper" class="histogram-content overflow-x-scroll">
        <svg ref="popupChartContainer" class="w-100 h-auto" preserveAspectRatio="xMidYMid meet"></svg>
      </div>
    </div>
  </enlargerpopup>
</template>

<script>
/* eslint-disable */
import * as d3 from "d3";
import enlargerpopup from "../AiCharts/popupfiles/enlarge_popup.vue";
import * as XLSX from "xlsx";
import html2pdf from "html2pdf.js";
import store from "../../store";
import axios from "axios";

import chartEmptyStateMixin from "./chartEmptyStateMixin";

export default {
  name: "BarChart",
  mixins: [chartEmptyStateMixin],
  components: { enlargerpopup },
  props: {
    data: { type: Array, required: true, default: () => [] },
    availableColumns: { type: Array, required: true, default: () => [] },
    loader: { type: Boolean, default: false },
    barlabelvertical: { type: Boolean, default: false },
    xAxisKey: { type: String, default: "AEOUT" },
    yAxisKey: { type: String, default: "AEYN" },
    yAxisLabel: { type: String, default: "Count" },
    xAxisLabel: { type: String, default: "" },
    chartlabel: { type: String, default: "Bar chart" },
    fromPage: { type: String, default: "" },
    graphheight: { type: Number, default: 400 },
    drilldowneabled: { type: Boolean, default: true },
    sort: { type: String, default: "" },
    preset: { type: String, default: "" }, // "etmfStatusBuckets"
    width: { type: Number, default: 800 },  // legacy fallback
  },
  data() {
    return {
      basetestUrl: process.env.VUE_APP_Service_URL,
      studyId: "",
      showVisitPopup: false,
      attributeOptions: [],
      selectedxaxis: "",
      selectedyaxis: "",
      color: null,
      expandBlock: false,

      // drilldown state
      selectedGroups: [],
      sortdata: [],
      filterarray: [],
      filterkeyword: "",

      // sizing
      view: { w: 800, h: 400 },
      popupView: { w: 1200, h: 500 },
      margin: { top: 24, right: 24, bottom: 56, left: 56 }, // base; will be adjusted dynamically
      minBarWidth: 24,
      maxLabelAngle: 45,
    };
  },
  mounted() {
    this.studyId = (store && store.getters && store.getters.getStudyIs) ? store.getters.getStudyIs : "";
    this.extractAttributeOptions();

    this.selectedxaxis = this.xAxisKey;
    this.selectedyaxis = this.yAxisKey;

    this.recomputeSize();
    this.createBarChart();

    if (window.ResizeObserver && this.$refs.chartWrapper) {
      this._ro = new ResizeObserver(() => {
        this.recomputeSize();
        this.createBarChart();
      });
      this._ro.observe(this.$refs.chartWrapper);
    }
  },
  watch: {
    data: {
      handler() {
        this.extractAttributeOptions();
        this.cancelselection();
        this.recomputeSize();
        this.createBarChart();
      },
      deep: true,
    },
    selectedxaxis() {
      this.cancelselection();
      this.recomputeSize();
      this.createBarChart();
    },
    selectedyaxis() {
      this.recomputeSize();
      this.createBarChart();
    },
    expandBlock(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          if (window.ResizeObserver && this.$refs.popupWrapper) {
            this._pro && this._pro.disconnect();
            this._pro = new ResizeObserver(() => {
              this.recomputeSize(true);
              this.createBarChart();
            });
            this._pro.observe(this.$refs.popupWrapper);
          }
          this.recomputeSize(true);
          this.createBarChart();
        });
      } else {
        this._pro && this._pro.disconnect();
      }
    },
  },
  beforeUnmount() {
    this._ro && this._ro.disconnect();
    this._pro && this._pro.disconnect();
  },
  methods: {
    /* ---------- Export ---------- */
    async exporttoexcell() { this.$emit("exporttoexcell"); },
    exporttopdf() {
      const excludeElement = this.$refs.excludeThis;
      if (excludeElement) excludeElement.style.display = "none";
      const pdfContainer = document.createElement("div");
      const captureArea = this.$refs.captureArea ? this.$refs.captureArea.cloneNode(true) : null;
      if (!captureArea) return;
      pdfContainer.appendChild(captureArea);
      pdfContainer.style.width = "100%";
      pdfContainer.style.display = "block";
      const opt = {
        margin: 0,
        filename: (this.chartlabel || "chart") + ".pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: { unit: "pt", format: "a4", orientation: "landscape" },
      };
      html2pdf().set(opt).from(pdfContainer).save();
    },

    /* ---------- Utility ---------- */
    extractAttributeOptions() {
      const arr = Array.isArray(this.data) ? this.data : [];
      if (arr.length > 0) {
        if (!this.availableColumns || this.availableColumns.length === 0) {
          const keys = Object.keys(arr[0] || {});
          this.attributeOptions = keys.filter((k) => k !== "_id" && k !== "STUDYID" && k !== "USUBJID");
        } else {
          this.attributeOptions = this.availableColumns.slice();
        }
      }
    },
    showtable() { this.$emit("opendrillpopup", Array.isArray(this.data) ? this.data : []); },
    async cancelselection() {
      this.selectedGroups = [];
      this.sortdata = [];
      this.filterarray = [];
      this.filterkeyword = "";
      this.createBarChart();
    },
    onClosePopup() {
      this.expandBlock = false;
      this.$nextTick(() => {
        this.recomputeSize(false);
        this.createBarChart();
      });
    },

    /* ---------- Dimensioning (adds extra bottom margin) ---------- */
    recomputeSize(isPopup = false) {
      const wrapper = isPopup ? this.$refs.popupWrapper : this.$refs.chartWrapper;
      const view = isPopup ? this.popupView : this.view;

      const w = wrapper && wrapper.clientWidth ? wrapper.clientWidth : (isPopup ? Math.max(this.width, 900) : Math.max(this.width, 600));
      const catCount = this.estimateCategoryCount();
      const barSpace = Math.max(catCount * this.minBarWidth, this.graphheight);
      // const baseH = Math.min(Math.max(barSpace, 260), 900);
       const baseH = 320;

      // dynamic bottom margin: more room when labels rotate + room for xAxisLabel
      const willRotate = this.barlabelvertical || w < 520 || (catCount > 12);
      const bottomForTicks = willRotate ? 84 : 48;
      const bottomForAxisTitle = this.xAxisLabel ? 22 : 0;
      // small extra cushion so labels don�t collide
      const dynamicBottom = bottomForTicks + bottomForAxisTitle + 8;

      this.margin = { top: 24, right: 24, bottom: dynamicBottom, left: 56 };

      view.w = Math.max(320, w);
      view.h = baseH;

      const targetSvg = isPopup ? this.$refs.popupChartContainer : this.$refs.chartContainer;
      if (targetSvg) d3.select(targetSvg).attr("viewBox", `0 0 ${view.w} ${view.h}`);
    },
    estimateCategoryCount() {
      if (this.preset === "etmfStatusBuckets") return 3;
      const arr = Array.isArray(this.data) ? this.data : [];
      const key = this.selectedxaxis || this.xAxisKey;
      const set = {};
      for (let i = 0; i < arr.length; i++) {
        const v = (arr[i] && arr[i][key] != null) ? String(arr[i][key]) : "N/A";
        set[v] = true;
      }
      const count = Object.keys(set).length;
      return count > 0 ? count : 5;
    },

    /* ---------- Data prep ---------- */
    getGroupedData() {
      const rows = Array.isArray(this.data) ? this.data : [];
      const xKey = this.selectedxaxis || this.xAxisKey;
      const yKey = this.selectedyaxis || this.yAxisKey;

      const numeric = rows.length > 0 && typeof rows[0][yKey] === "number";
      const map = {};
      for (let i = 0; i < rows.length; i++) {
        const r = rows[i];
        const x = (r && r[xKey] != null) ? String(r[xKey]) : "N/A";
        if (!map[x]) map[x] = 0;
        map[x] += numeric ? (typeof r[yKey] === "number" ? r[yKey] : 0) : 1;
      }
      const grouped = Object.keys(map).map(k => [k, map[k]]);
      if (this.sort === "asc") grouped.sort((a, b) => a[1] - b[1]);
      else if (this.sort === "desc") grouped.sort((a, b) => b[1] - a[1]);
      return grouped;
    },

    /* ---------- MAIN DRAW (vertical bars) ---------- */
    createBarChart() {
  const svg = d3.select(this.expandBlock ? this.$refs.popupChartContainer : this.$refs.chartContainer);
  svg.selectAll("*").remove();
  if (!svg.node()) return;

  const view = this.expandBlock ? this.popupView : this.view;
  const m = this.margin;
  const innerW = Math.max(10, view.w - m.left - m.right);
  const innerH = Math.max(10, view.h - m.top - m.bottom);

  const root = svg.append("g").attr("transform", `translate(${m.left},${m.top})`);

  if (!this.color || typeof this.color.domain !== "function") {
    this.color = d3.scaleOrdinal().range(["#FF9800", "#dc3545"].concat(d3.schemeCategory10));
  }

  /* ===== PRESET: ETMF (vertical) ===== */
  if (this.preset === "etmfStatusBuckets") {
    const entities = Array.isArray(this.data) ? this.data : [];
    const now = new Date();
    const in7 = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);

    function statusStr(e) {
      const s = e && e.documentVersion && e.documentVersion.versionStatus ? String(e.documentVersion.versionStatus) : "";
      return s.trim().toLowerCase();
    }
    function isCompleted(e) {
      return statusStr(e) === "completed";
    }
    function parseDate(raw) {
      if (!raw) return null;
      const dt = new Date(raw);
      return isNaN(dt) ? null : dt;
    }
    function isDueSoon(e) {
      if (isCompleted(e)) return false;
      const dt = parseDate(e?.documentVersion?.expectedCompletionDate);
      return !!dt && dt >= now && dt < in7;
    }
    function isExpired(e) {
      if (isCompleted(e)) return false;
      const dt = parseDate(e?.documentVersion?.expectedCompletionDate);
      return !!dt && dt < now;
    }

    // Buckets: Completed, Due in < 7 days, Expired
    const bucketRows = { "Completed": [], "Due in < 7 days": [], "Expired": [] };

    for (let i = 0; i < entities.length; i++) {
      const e = entities[i];
      if (isCompleted(e)) bucketRows["Completed"].push(e);
      else if (isDueSoon(e)) bucketRows["Due in < 7 days"].push(e);
      else if (isExpired(e)) bucketRows["Expired"].push(e);
      // Items with no date or due > 7 days are intentionally excluded
    }

    const dataArr = [
      ["Due in < 7 days", bucketRows["Due in < 7 days"].length],
      ["Expired", bucketRows["Expired"].length],
    ];
    this.color.domain(dataArr.map(d => d[0]));

    const x = d3.scaleBand().domain(dataArr.map(d => d[0])).range([0, innerW]).padding(0.2);
    const y = d3.scaleLinear().domain([0, d3.max(dataArr, d => d[1]) || 0]).nice().range([innerH, 0]);

    const gx = root.append("g").attr("transform", `translate(0,${innerH})`).call(d3.axisBottom(x));
    this.maybeRotateLabels(gx, x.bandwidth(), innerW);
    root.append("g").call(d3.axisLeft(y).ticks(5));

    if (this.xAxisLabel) {
      root.append("text")
        .attr("x", innerW / 2)
        .attr("y", innerH + (this.barlabelvertical ? 188 : 80))  // further down so no overlap
        .attr("text-anchor", "middle")
        .attr("font-size", "13px")
        .text(this.xAxisLabel);
    }
    if (this.yAxisLabel) {
      root.append("text")
        .attr("transform", "rotate(-90)")
        .attr("x", -(innerH / 2))
        .attr("y", -40)
        .attr("text-anchor", "middle")
        .attr("font-size", "13px")
        .text(this.yAxisLabel || "Count");
    }

    root.selectAll("rect")
      .data(dataArr)
      .enter()
      .append("rect")
      .attr("x", d => x(d[0]))
      .attr("y", d => y(d[1]))
      .attr("width", x.bandwidth())
      .attr("height", d => innerH - y(d[1]))
      .attr("fill", d => this.color(d[0]))
      .attr("opacity", d => (this.selectedGroups.length === 0 || this.selectedGroups.indexOf(d[0]) > -1 ? 1 : 0.5))
      .on("mouseover", (event, d) => this.showTip(event, `Category: ${d[0]}<br>Count: ${d[1]}`))
      .on("mouseout", () => this.hideTip())
      .on("mousemove", (event) => this.moveTip(event))
      .on("click", (_evt, d) => this.clickbarinchart(bucketRows[d[0]] || [], d[0]));

    root.selectAll("text.bar-label")
      .data(dataArr)
      .enter()
      .append("text")
      .attr("class", "bar-label")
      .attr("text-anchor", "middle")
      .attr("x", d => (x(d[0]) || 0) + x.bandwidth() / 2)
      .attr("y", d => y(d[1]) - 6)
      .text(d => d[1]);

    return;
  }

  /* ===== Generic vertical bar chart ===== */
  const grouped = this.getGroupedData();

  const x = d3.scaleBand().domain(grouped.map(d => d[0])).range([0, innerW]).padding(0.2);
  const y = d3.scaleLinear().domain([0, d3.max(grouped, d => d[1]) || 0]).nice().range([innerH, 0]);

  const gx = root.append("g").attr("transform", `translate(0,${innerH})`).call(d3.axisBottom(x));
  this.maybeRotateLabels(gx, x.bandwidth(), innerW);
  root.append("g").call(d3.axisLeft(y).ticks(5));

  if (this.xAxisLabel || this.selectedxaxis) {
    root.append("text")
      .attr("x", innerW / 2)
      .attr("y", innerH + (this.barlabelvertical ? 68 : 40))  // pushed down to avoid overlap
      .attr("text-anchor", "middle")
      .attr("font-size", "13px")
      .text(this.xAxisLabel || this.selectedxaxis);
  }
  if (this.yAxisLabel) {
    root.append("text")
      .attr("transform", "rotate(-90)")
      .attr("x", -(innerH / 2))
      .attr("y", -40)
      .attr("text-anchor", "middle")
      .attr("font-size", "13px")
      .text(this.yAxisLabel);
  }

  this.color.domain(grouped.map(d => d[0]));

  root.selectAll("rect")
    .data(grouped)
    .enter()
    .append("rect")
    .attr("x", d => x(d[0]))
    .attr("y", d => y(d[1]))
    .attr("width", x.bandwidth())
    .attr("height", d => innerH - y(d[1]))
    .attr("fill", d => this.color(d[0]))
    .attr("opacity", d => (this.selectedGroups.length === 0 || this.selectedGroups.indexOf(d[0]) > -1 ? 1 : 0.5))
    .on("mouseover", (event, d) => this.showTip(event, `Category: ${d[0]}<br>Value: ${d[1]}`))
    .on("mouseout", () => this.hideTip())
    .on("mousemove", (event) => this.moveTip(event))
    .on("click", (_evt, d) => {
      const rows = [];
      const arr = Array.isArray(this.data) ? this.data : [];
      const key = this.selectedxaxis || this.xAxisKey;
      for (let i = 0; i < arr.length; i++) {
        const v = (arr[i] && arr[i][key] != null) ? String(arr[i][key]) : "N/A";
        if (v === d[0]) rows.push(arr[i]);
      }
      this.clickbarinchart(rows, d[0]);
    });

  root.selectAll("text.bar-label")
    .data(grouped)
    .enter()
    .append("text")
    .attr("class", "bar-label")
    .attr("text-anchor", "middle")
    .attr("x", d => (x(d[0]) || 0) + x.bandwidth() / 2)
    .attr("y", d => y(d[1]) - 6)
    .text(d => d[1]);
},

    /* ---------- Tooltip using true cursor coords ---------- */
    showTip(event, html) {
      const t = this.$refs.tooltip;
      if (!t) return;
      t.style.opacity = 1;
      t.innerHTML = html;
      this.moveTip(event);
    },
    moveTip(event) {
      const t = this.$refs.tooltip;
      if (!t) return;
      const offset = 12; // small offset from cursor
      const x = (event.clientX || 0) + offset;
      const y = (event.clientY || 0) + offset;
      t.style.left = x + "px";
      t.style.top = y + "px";
    },
    hideTip() {
      const t = this.$refs.tooltip;
      if (!t) return;
      t.style.opacity = 0;
    },

    /* ---------- Labels & drilldown ---------- */
    maybeRotateLabels(g, bandW, totalW) {
      const rotate = this.barlabelvertical || bandW < 48 || totalW < 520;
      if (!rotate) return;
      try {
        g.selectAll("text")
          .attr("text-anchor", "end")
          .attr("transform", `rotate(-${this.maxLabelAngle})`)
          .attr("dx", "-0.6em")
          .attr("dy", "0.25em");
      } catch (e) {}
    },

    clickbarinchart(filteredData, filteredkeyword) {
      const idx = this.selectedGroups.indexOf(filteredkeyword);
      if (idx > -1) {
        this.selectedGroups.splice(idx, 1);

        const removeIds = {};
        for (let i = 0; i < filteredData.length; i++) {
          const row = filteredData[i];
          const vid = row && row.documentVersion ? row.documentVersion.versionId : null;
          if (vid) removeIds[vid] = true;
        }
        const remain = [];
        for (let j = 0; j < this.sortdata.length; j++) {
          const vid2 = this.sortdata[j] && this.sortdata[j].documentVersion ? this.sortdata[j].documentVersion.versionId : null;
          if (!vid2 || !removeIds[vid2]) remain.push(this.sortdata[j]);
        }
        this.sortdata = remain;

        const tag = "(" + filteredkeyword + ")";
        this.filterarray = this.filterarray.filter(t => t !== tag);
      } else {
        this.selectedGroups.push(filteredkeyword);
        this.filterarray.push("(" + filteredkeyword + ")");

        const have = {};
        for (let i = 0; i < this.sortdata.length; i++) {
          const vid = this.sortdata[i] && this.sortdata[i].documentVersion ? this.sortdata[i].documentVersion.versionId : null;
          if (vid) have[vid] = true;
        }
        for (let i = 0; i < filteredData.length; i++) {
          const row = filteredData[i];
          const vid = row && row.documentVersion ? row.documentVersion.versionId : null;
          if (vid && !have[vid]) {
            this.sortdata.push(row);
            have[vid] = true;
          }
        }
      }

      this.filterkeyword = (this.selectedxaxis || this.xAxisKey) + "(" + this.selectedGroups.join(",") + ")";
      this.createBarChart();
    },
    recreatechart() {
      const dataToEmit = {
        sortedData: this.sortdata.slice(),
        filterkeyword: this.filterkeyword,
      };
      this.$emit("drilldowncurrentchart", dataToEmit);
    },
  },
};
</script>

<style scoped>
@import "../../custom_lib/AiCharts/charts.css";

svg { font-size: 10px; display: block; }
text.bar-label { fill: black; font-size: 12px; }

.loader {
  border: 6px solid #f3f3f3;
  border-top: 6px solid #3498db;
  border-radius: 50%;
  width: 40px; height: 40px;
  animation: spin 1s linear infinite; margin: 0 auto;
}
@keyframes spin { 0% { transform: rotate(0deg);} 100% { transform: rotate(360deg);} }

.overflow-x-auto, .overflow-x-scroll { overflow-x: auto; }

/* tooltip positioned by clientX/clientY (viewport coords) */
.tooltip {
  position: fixed;
  z-index: 9999;
  pointer-events: none;
  opacity: 0;
  padding: 6px 8px;
  background: rgba(0,0,0,0.75);
  color: #fff;
  border-radius: 4px;
  font-size: 12px;
}
</style>
